import { HomeOutlined, PlusOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import { Button, Col, Row } from "antd";
import { Header } from "components/common/header/Header";
import { CompanyGroupList } from "./CompanyGroupList";
import { CompanyGroupForm } from "./CompanyGroupForm";

export const CompanyGroup = () => {
  const [companyListRefresher, setCompanyListRefresher] = useState(1);
  const [groupId, setGroupId] = useState(0);

  return (
    <div className="other-page-wrapper">
      <Header
        heading="Create Company Group"
        info="Use this feature to establish a new Company Group. A Company Group is a collection of related companies that can be managed together, sharing resources and strategies. This is beneficial for organizing and overseeing multiple companies under a single entity. Click here to begin setting up a new Company Group"
        classes="mb-10"
        extraStartBtn={
          <Button
            type="primary"
            style={{ color: "#fff", marginLeft: "20px", borderRadius: 6 }}
            icon={<PlusOutlined />}
            size={"middle"}
            onClick={() => {
              setGroupId(0);
            }}
          >
            Add New Company Group
          </Button>
        }
        breadcrumbs={[
          {
            icon: <HomeOutlined></HomeOutlined>,
            url: "/",
          },
          {
            url: "/company-group/list",
            title: "Create Company Group",
          },
        ]}
      ></Header>
      <Row>
        <Col span={12}>
          <CompanyGroupList
            setGroupId={setGroupId}
            companyGroupRefresher={companyListRefresher}
          ></CompanyGroupList>
        </Col>
        <Col span={12}>
          <CompanyGroupForm
            groupId={groupId}
            onCompanyAdded={() => {
              setGroupId(0);
              setCompanyListRefresher(Math.random());
            }}
          ></CompanyGroupForm>
        </Col>
      </Row>
    </div>
  );
};
